// Generated by CoffeeScript 2.7.0
var Admin__TagsController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import TagGroupsSidebar from 'trunks/vue/admin/compositions/tags_groups/tags_group_sidebar.js';

import UserTaggables from 'trunks/vue/admin/compositions/tags_groups/taggables/user_taggables.js';

import GenerateUserProfile from 'trunks/controllers/admin/user_profile/generate_profile.js';

import ReceiptTaggables from 'trunks/vue/admin/compositions/tags_groups/taggables/receipt_taggables.js';

export default Admin__TagsController = (function() {
  class Admin__TagsController extends Skylark.App.BaseController {
    taggables() {
      this.page = this.getVars();
      this._generateTagGroupsSidebar(this.page.tag_group_type, String(this.page.tag.tag_group_id));
      return this._generateTaggables();
    }

    _generateTaggables() {
      var taggables_container;
      taggables_container = DomMaster.find("#taggables_container").node;
      return this._generateUserProfile((profileSchema) => {
        if (this.page.tag_group_type === 'user') {
          return new UserTaggables({
            el: taggables_container,
            propsData: {
              tag: this.page.tag,
              fieldable: {
                fields: profileSchema.fields
              },
              profileSchema: profileSchema
            }
          });
        } else {
          return new ReceiptTaggables({
            el: taggables_container,
            propsData: {
              tag: this.page.tag
            }
          });
        }
      });
    }

  };

  Admin__TagsController.include(GenerateMorePopover);

  Admin__TagsController.include(TagGroupsSidebar);

  Admin__TagsController.include(GenerateUserProfile);

  return Admin__TagsController;

}).call(this);
